function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M17.5 0C9.54545 0 2.75227 4.94773 0 11.9318C2.75227 18.9159 9.54545 23.8636 17.5 23.8636C25.4545 23.8636 32.2477 18.9159 35 11.9318C32.2477 4.94773 25.4545 0 17.5 0ZM17.4999 19.8868C13.109 19.8868 9.54539 16.3231 9.54539 11.9322C9.54539 7.5413 13.109 3.97766 17.4999 3.97766C21.8908 3.97766 25.4545 7.5413 25.4545 11.9322C25.4545 16.3231 21.8908 19.8868 17.4999 19.8868ZM12.7269 11.9319C12.7269 9.29104 14.8588 7.15922 17.4997 7.15922C20.1406 7.15922 22.2724 9.29104 22.2724 11.9319C22.2724 14.5729 20.1406 16.7047 17.4997 16.7047C14.8588 16.7047 12.7269 14.5729 12.7269 11.9319Z",
  fill: "#1C355E"
});

var SvgEye = function SvgEye(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 35,
    height: 24,
    viewBox: "0 0 35 24",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgEye, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/eye.d1beeba0.svg";
export { ForwardRef as ReactComponent };